import { CoreModule } from 'app/modules/core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SearchService } from 'app/modules/search-module/services/search.service';
import { SearchRoutingModule } from 'app/modules/search-module/search-routing.module';
import { AggregationSliderComponent } from 'app/modules/search-module/components/aggregation-slider/aggregation-slider.component';
import { AggregationRangeComponent } from 'app/modules/search-module/components/aggregation-range/aggregation-range.component';
import { AggregationItemComponent } from 'app/modules/search-module/components/aggregation-item/aggregation-item.component';
import { AggregationBlockComponent } from 'app/modules/search-module/components/aggregation-block/aggregation-block.component';
import { TeaserBlockComponent } from 'app/modules/search-module/components/teaser-block/teaser-block.component';
import { FilterBarComponent } from 'app/modules/search-module/components/filter-bar/filter-bar.component';
import { PaginationComponent } from 'app/modules/search-module/components/pagination/pagination.component';
import { TabsComponent } from 'app/modules/search-module/components/tabs/tabs.component';

import { NgPipesModule } from 'ngx-pipes';
import { ProjectModule } from 'app/modules/project/project.module';

import { WordsPipe } from 'app/modules/search-module/pipes/words.pipe';
import { SortPipe } from 'app/modules/search-module/pipes/sort.pipe';
import { SearchContainerComponent } from './components/search-container/search-container.component';
import { ProjectSearchComponent } from 'app/modules/search-module/components/project-search/project-search.component';
import { DetailSearchComponent } from './components/detail-search/detail-search.component';
import { FilterCategoryComponent } from './components/filter-category/filter-category.component';

@NgModule({
  imports: [
    CommonModule,
    SearchRoutingModule,
    FormsModule,
    NgPipesModule,
    ProjectModule,
    CoreModule
  ],
  declarations: [
    AggregationBlockComponent,
    AggregationItemComponent,
    AggregationRangeComponent,
    AggregationSliderComponent,
    FilterBarComponent,
    ProjectSearchComponent,
    TeaserBlockComponent,
    PaginationComponent,
    WordsPipe,
    SortPipe,
    SearchContainerComponent,
    DetailSearchComponent,
    TabsComponent,
    FilterCategoryComponent
  ],
  exports: [
    ProjectSearchComponent, TeaserBlockComponent
  ],
  providers: [SearchService]
})
export class SearchModule { }
